export default "__VITE_ASSET__BknjT7rO__"